import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { catalogConfig, getConfig, URLS } from '@constants';

import { EAppsCounters, EContext, ERefsApps, EResponseStatus, EStore } from '@enums';

import { counters } from '@utils';

import { commonWillUnmount, fetchData, Translate } from '@decorators';

import { IAppState } from '@stores';

import {
	CompilationPage,
	EPositionHorizontal,
	EPositionVertical,
	IAppItem,
	IDropdownOption,
	OuterWrapper,
} from '@components';

import { ICGIUrlOptions } from '@interfaces';

import { IPropsCatalogInstalled } from './types';

@inject(
	EStore.APPS_INSTALLED,
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.COUNTERS,
)
@observer
@Translate('pages.AppsCatalog.CatalogInstalled')
@commonWillUnmount()
@fetchData([
	async ({ appsInstalledStore, currentUserStore: { currentUser } }: IAppState) => {
		if (appsInstalledStore.status !== EResponseStatus.OK) {
			const limit = currentUser?.isMyCreated
				? catalogConfig.appsLimit.auth
				: catalogConfig.appsLimit.guest;

			await appsInstalledStore.fetch({
				context: EContext.MOBILE,
				limit,
				offset: appsInstalledStore.data.offset,
				user: currentUser,
			});
		}
	},

	// UI STATE
	({ uiStore }: IAppState) => {
		if (uiStore.status !== EResponseStatus.OK) {
			uiStore.setTopMenuInitialState({
				backButtonUrl: getConfig().apps.pathname || URLS.APPS,
			});
		}
	},
])
export class CatalogInstalled extends React.Component<IPropsCatalogInstalled> {

	getAppOptionsDropdownConfig(app: IAppItem) {
		const options: IDropdownOption[] = [
			{
				title: this.t('delete'),
				onClickAction: () => this.removeInstalledApp(app),
			},
		];

		if (app.communityUrl && !getConfig().isTwa) {
			options.unshift( {
				title: this.t('group'),
				url: app.communityUrl,
				isBlank: !!(getConfig().isTwa),
			});
		}

		return ({
			positionVertical: EPositionVertical.BOTTOM,
			positionHorizontal: EPositionHorizontal.LEFT,
			options,
		});
	};

	removeInstalledApp = (app: IAppItem) => {
		counters.sendRB(EAppsCounters.APP_REMOVE);
		this.props.appsInstalledStore.uninstallApp(app.id);
	};

	fetchApps = async (options: ICGIUrlOptions) =>
		await this.props.appsInstalledStore.fetch({
			...options,
			offset: this.props.appsInstalledStore.data.offset,
		});

	fetchAppsNext = async (options: ICGIUrlOptions) =>
		await this.props.appsInstalledStore.fetchNext({
			...options,
			offset: this.props.appsInstalledStore.data.offset,
		});

	render() {
		const store = this.props.appsInstalledStore;
		const appsListOptions = {
			apps: store.data?.apps || [],
			responseStatus: store.status,
			urlRef: ERefsApps.PAGE_INSTALLED,
			hasGenres: true,
			getAppOptionsDropdownConfig: this.getAppOptionsDropdownConfig.bind(this),
		};

		return (
			<OuterWrapper>
				<CompilationPage
					appsListOptions={appsListOptions}
					fetchApps={this.fetchApps}
					fetchAppsNext={this.fetchAppsNext}
					compilationDescription={getConfig().apps?.compilationDescription?.installed}
					total={store?.data?.total}
					hasMore={store?.data?.hasMore}
				/>
			</OuterWrapper>
		);
	}

}
